import './styles/login.header.styles.scss';
import { NavigationManager } from 'src/_shared/managers/navigation.manager';
import { useStoreSelector } from 'src/_shared/store/hook';
import { RouteEnum } from 'src/_shared/routes';
import { User } from 'src/api/entities/user';
import { store } from 'src/_shared/store/configure';
import { logout } from 'src/features/access/state/access.slice';

const LoginHeader: React.FC = () => {
    const isHome = useStoreSelector(state => state.reducer.shared.currentRoute);
    const navigationManager = NavigationManager.getInstance();
    const user: User = useStoreSelector(state => state.reducer.accessSlice.loggedUser);

    const sectionTitle: string = (() => {
        switch (navigationManager.getCurrentRoute()) {
            case RouteEnum.customersWorkouts:
                return 'Customer workouts';
            case RouteEnum.exercises:
                return 'Esercizi';
            case RouteEnum.customers:
                return 'Clienti';
            case RouteEnum.customersDetails:
                return 'Dettaglio cliente';
            default:
                return '';
        }
    })();

    const handleLogout = () => {
        store.dispatch(logout());
    };

    const getInitials = () => {
        const name = user.data?.details?.firstName ?? user.username ?? '';
        const last = user.data?.details?.lastName ?? '';
        const first = name[0] ?? '';
        const lastInitial = last[0] ?? '';
        return (first + lastInitial).toUpperCase() || '?';
    };

    return (
        <div className='topbar'>
            <div className='topbar-inner'>
                <div className='topbar-left'>
                    {sectionTitle && (
                        <h6 className='topbar-title'>{sectionTitle}</h6>
                    )}
                </div>
                <div className='topbar-right'>
                    <div className='topbar-user-pill'>
                        <div className='topbar-avatar'>
                            {getInitials()}
                        </div>
                        <div className='topbar-user-info'>
                            <span className='topbar-user-name'>
                                {user.data?.details?.firstName ?? user.username}
                            </span>
                            {user.email && (
                                <span className='topbar-user-email'>{user.email}</span>
                            )}
                        </div>
                    </div>
                    <button className='topbar-logout-btn' onClick={handleLogout} title='Esci'>
                        <i className='bi bi-box-arrow-right'></i>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LoginHeader;
